import mapStyles from "./mapStyles";

const smallScreenSize = window.innerWidth <= 768 || window.innerHeight <= 768;

const options = {
  disableDefaultUI: true,
  panControl: true,
  styles: mapStyles,
  zoomControl: true,
  clickableIcons: false,
};

const libraries = ["places"];

export { libraries, options, smallScreenSize };
